module.exports = __webpack_public_path__ + "static/media/tfs.336f8c1b.png";